import LayoutAuth from "@/layouts/LayoutAuth.vue";
import LayoutSistem from "@/layouts/LayoutSistem.vue";

export default [
  {
    path: "/",
    name: "inicio",
    component: () => import(/* webpackChunkName: "inicio" */ "@/views/HomeView.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/"]
    }
  },
  {
    path: "/ficha-individual/:id/:token",
    name: "ficha-individual-publico",
    component: () => import(/* webpackChunkName: "login" */ "@/views/publico/FichaIndividual.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/ficha-rural/:id/:token",
    name: "ficha-rural-publico",
    component: () => import(/* webpackChunkName: "login" */ "@/views/publico/FichaRural.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/ficha-economica/:id/:token",
    name: "ficha-economica-publico",
    component: () => import(/* webpackChunkName: "login" */ "@/views/publico/FichaEconomica.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/ficha-cotitular-rural/:id/:token",
    name: "ficha-cotitular-rural-publico",
    component: () => import(/* webpackChunkName: "login" */ "@/views/publico/FichaCotitularidadRural.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/ficha-bien-comun/:id/:token",
    name: "ficha-bien-comun-publico",
    component: () => import(/* webpackChunkName: "login" */ "@/views/publico/FichaBienesComunes.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/ficha-bien-cultural/:id/:token",
    name: "ficha-bien-cultural-publico",
    component: () => import(/* webpackChunkName: "login" */ "@/views/publico/FichaBienesCulturales.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/ficha-cotitular/:id/:token",
    name: "ficha-cotitular-publico",
    component: () => import(/* webpackChunkName: "login" */ "@/views/publico/FichaCotitularidad.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  /*{
    path: "/plano",
    name: "plano",
    component: () => import("@/views/publico/PlanoCatastralV2.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  }*/,
  {
    path: "/forgot",
    name: "forgot",
    component: () => import(/* webpackChunkName: "forgot" */ "@/views/auth/ForgotPassword.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/recover",
    name: "recover",
    component: () => import(/* webpackChunkName: "forgot" */ "@/views/auth/RecoverPassword.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/auth/Login.vue"),
    meta: {
      layout: LayoutAuth,
      isPublic: true
    }
  },
  {
    path: "/fichacatastral",
    name: "fichacatastral",
    component: () =>
      import(/* webpackChunkName: "fichacatastral" */ "@/views/busqueda/FichaCatastral.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/fichacatastral"]
    }
  },
  {
    path: "/mi-cuenta",
    name: "micuenta",
    component: () => import(/* webpackChunkName: "micuenta" */ "@/views/auth/MiCuenta.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/micuenta"]
    }
  },
  {
    path: "/script",
    name: "script",
    component: () => import(/* webpackChunkName: "script" */ "@/views/configuracion/Script.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: true,
      availableRoute: ["/script"]
    }
  },
  {
    path: "/perfil",
    name: "perfil",
    component: () =>
      import(/* webpackChunkName: "perfiles" */ "@/views/configuracion/Perfiles.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/perfil"]
    }
  },
  {
    path: "/scripts-editar",
    name: "scripts-editar",
    component: () =>
      import(/* webpackChunkName: "script-editar" */ "@/views/configuracion/ScriptAddEdit.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: true,
      availableRoute: ["/script"]
    }
  },
  {
    path: "/scripts-editar/:id",
    name: "scripts-editar-id",
    component: () =>
      import(/* webpackChunkName: "script-editar-id" */ "@/views/configuracion/ScriptAddEdit.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: true,
      availableRoute: ["/script"]
    }
  },
  {
    path: "/usuario",
    name: "usuario",
    component: () =>
      import(/* webpackChunkName: "usuarios" */ "@/views/configuracion/Usuarios.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: true,
      availableRoute: ["/usuario"]
    }
  },
  {
    path: "/formato",
    name: "formato",
    component: () => import(/* webpackChunkName: "formato" */ "@/views/configuracion/Formato.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: true,
      availableRoute: ["/formato"]
    }
  },
  {
    path: "/formatos-editar",
    name: "formatos-editar",
    component: () =>
      import(/* webpackChunkName: "formato-editar" */ "@/views/configuracion/FormatoAddEdit.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: true,
      availableRoute: ["/formato"]
    }
  },
  {
    path: "/formatos-editar/:id",
    name: "formatos-editar-id",
    component: () =>
      import(
        /* webpackChunkName: "formato-editar-id" */ "@/views/configuracion/FormatoAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: true,
      availableRoute: ["/formato"]
    }
  },
  {
    path: "/modulo",
    name: "modulo",
    component: () => import(/* webpackChunkName: "modulo" */ "@/views/configuracion/Modulo.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/modulo"]
    }
  },
  {
    path: "/parametro",
    name: "parametro",
    component: () =>
      import(/* webpackChunkName: "parametro" */ "@/views/configuracion/Parametro.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/parametro"]
    }
  },
  {
    path: "/ayuda",
    name: "ayuda",
    component: () => import(/* webpackChunkName: "parametro" */ "@/views/configuracion/Ayuda.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ayuda"]
    }
  },
  {
    path: "/catalogo",
    name: "catalogo",
    component: () => import(/* webpackChunkName: "catalogos" */ "@/views/catalogo/Catalogo.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/catalogo"]
    }
  },
  {
    path: "/ubicaciongeografica",
    name: "ubicaciongeografica",
    component: () =>
      import(
        /* webpackChunkName: "ubicaciongeografica" */ "@/views/catalogo/UbicacionGeografica.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ubicaciongeografica"]
    }
  },
  {
    path: "/centropoblado",
    name: "centropoblado",
    component: () =>
      import(/* webpackChunkName: "centropoblado" */ "@/views/catalogo/CentroPoblado.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/centropoblado"]
    }
  },
  {
    path: "/actividadeconomica",
    name: "actividadeconomica",
    component: () =>
      import(
        /* webpackChunkName: "actividadeconomica" */ "@/views/catalogo/ActividadEconomica.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/actividadeconomica"]
    }
  },
  {
    path: "/codigouso",
    name: "codigouso",
    component: () => import(/* webpackChunkName: "codigouso" */ "@/views/catalogo/CodigoUso.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/codigouso"]
    }
  },
  {
    path: "/codigoinstalacion",
    name: "codigoinstalacion",
    component: () =>
      import(/* webpackChunkName: "codigoinstalacion" */ "@/views/catalogo/CodigoInstalacion.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/codigoinstalacion"]
    }
  },
  {
    path: "/valoredificacion",
    name: "valoredificacion",
    component: () =>
      import(/* webpackChunkName: "valoredificacion" */ "@/views/catalogo/ValorEdificacion.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/valoredificacion"]
    }
  },
  {
    path: "/planocatastral",
    name: "planocatastral",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/PlanoCatastral.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/planocatastral"]
    }
  },
  {
    path: "/plano-agregar/:id",
    name: "plano-agregar",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/PlanoAgregar.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/plano-agregar"]
    }
  },
  {
    path: "/busqueda-habitacion-urbana",
    name: "busqueda-habitacion-urbana",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/HabitacionUrbana.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/busqueda-habitacion-urbana"]
    }
  },
  {
    path: "/coordenada",
    name: "coordenada",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/Coordenadas.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/coordenada"]
    }
  },
  {
    path: "/busqueda-lote",
    name: "busqueda-lote",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/busqueda/BusquedaLote.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/busqueda-lote"]
    }
  },
  {
    path: "/rentas-consulta",
    name: "rentas-consulta",
    component: () => import(/* webpackChunkName: "rentas" */ "@/views/rentas/ConsultaRentas.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/rentas-consulta"]
    }
  },
  {
    path: "/configuracion-microservicios",
    name: "configuracion-microservicios",
    component: () =>
      import(
        /* webpackChunkName: "configuracion" */ "@/views/configuracion/Microservicios.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/configuracion-microservicios"]
    }
  },
  {
    path: "/configuracion-auditoria",
    name: "configuracion-auditoria",
    component: () =>
      import(/* webpackChunkName: "configuracion" */ "@/views/configuracion/Auditoria.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/configuracion-auditoria"]
    }
  },
  {
    path: "/catastro-detalle/:idficha",
    name: "catastro-detalle",
    component: () =>
      import(/* webpackChunkName: "catastro-detalles" */ "@/views/documento/CatastroDetalle.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/catastro-detalle"]
    }
  },
  {
    path: "/notaria",
    name: "notaria",
    component: () => import(/* webpackChunkName: "direccion" */ "@/views/habilitacion/Notaria.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/notaria"]
    }
  },
  {
    path: "/direccion",
    name: "direccion",
    component: () =>
      import(/* webpackChunkName: "direccion" */ "@/views/habilitacion/Direccion.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/direccion"]
    }
  },
  {
    path: "/via",
    name: "via",
    component: () => import(/* webpackChunkName: "vias" */ "@/views/habilitacion/Via.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/via"]
    }
  },
  {
    path: "/habilitacion-urbana",
    name: "habilitacion-urbana",
    component: () =>
      import(
        /* webpackChunkName: "habilitacion-urbana" */ "@/views/habilitacion/HabilitacionUrbana.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/habilitacion-urbana"]
    }
  },
  {
    path: "/du-certificado-parametros",
    name: "du-certificado-parametros",
    component: () =>
      import(
        /* webpackChunkName: "desarrollo-urbano" */ "@/views/desarrollo-urbano/CertificadoParametros.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/du-certificado-parametros"]
    }
  },
  {
    path: "/du-certificado-alineamiento",
    name: "du-certificado-alineamiento",
    component: () =>
      import(
        /* webpackChunkName: "desarrollo-urbano" */ "@/views/desarrollo-urbano/CertificadoAlineamiento.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/du-certificado-alineamiento"]
    }
  },
  {
    path: "/du-certificado-zonificacion",
    name: "du-certificado-zonificacion",
    component: () =>
      import(
        /* webpackChunkName: "desarrollo-urbano" */ "@/views/desarrollo-urbano/CertificadoZonificacion.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/du-certificado-zonificacion"]
    }
  },
  {
    path: "/du-autorizacion",
    name: "du-autorizacion",
    component: () =>
      import(
        /* webpackChunkName: "desarrollo-urbano" */ "@/views/desarrollo-urbano/Autorizacion.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/du-autorizacion"]
    }
  },
  {
    path: "/sector",
    name: "sector",
    component: () => import(/* webpackChunkName: "sector" */ "@/views/estructura/Sector.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/sector"]
    }
  },
  {
    path: "/manzana",
    name: "manzana",
    component: () => import(/* webpackChunkName: "manzana" */ "@/views/estructura/Manzana.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/manzana"]
    }
  },
  {
    path: "/zona",
    name: "zona",
    component: () => import(/* webpackChunkName: "manzana" */ "@/views/estructura/Zona.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/zona"]
    }
  },
  {
    path: "/lote",
    name: "lote",
    component: () => import(/* webpackChunkName: "lote" */ "@/views/estructura/Lote.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/lote"]
    }
  },
  {
    path: "/personal",
    name: "personal",
    component: () => import(/* webpackChunkName: "personal" */ "@/views/registro/Personal.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/personal"]
    }
  },
  {
    path: "/entidad",
    name: "entidad",
    component: () => import(/* webpackChunkName: "entidad" */ "@/views/registro/Entidad.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/entidad"]
    }
  },

  /**
   * FICHA INDIVIDUAL
   */
  {
    path: "/ficha-individual",
    name: "ficha-individual",
    component: () =>
      import(/* webpackChunkName: "ficha-individual" */ "@/views/fichas/FichaIndividual.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual"]
    }
  },
  {
    path: "/ficha-individual-nf",
    name: "ficha-individual-nf",
    component: () =>
      import(/* webpackChunkName: "ficha-individual-nf" */ "@/views/fichas/FichaIndividual.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual-nf"]
    }
  },
  {
    path: "/ficha-individual/nuevo",
    name: "ficha-individual-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-individual-nuevo" */ "@/views/fichas/FichaIndividualAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual"]
    }
  },
  {
    path: "/ficha-individual-nf/nuevo",
    name: "ficha-individual-nf-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-individual-nf-nuevo" */ "@/views/fichas/FichaIndividualAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual-nf"]
    }
  },
  {
    path: "/ficha-individual/:idficha/editar",
    name: "ficha-individual-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-individual-editar" */ "@/views/fichas/FichaIndividualAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual"]
    }
  },
  {
    path: "/ficha-individual-nf/:idficha/editar",
    name: "ficha-individual-nf-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-individual-nf-editar" */ "@/views/fichas/FichaIndividualAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual-nf"]
    }
  },
  {
    path: "/ficha-individual/:idficha/show",
    name: "ficha-individual-show",
    component: () =>
      import(/* webpackChunkName: "ficha-individual-show" */ "@/views/fichas/ShowFichas.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual"]
    }
  },
  {
    path: "/ficha-individual-nf/:idficha/show",
    name: "ficha-individual-nf-show",
    component: () =>
      import(/* webpackChunkName: "ficha-individual-nf-show" */ "@/views/fichas/ShowFichas.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-individual-nf"]
    }
  },

  /**
   * FICHA COTITULAR
   */
  {
    path: "/ficha-cotitularidad",
    name: "ficha-cotitularidad",
    component: () =>
      import(/* webpackChunkName: "ficha-cotitularidad" */ "@/views/fichas/FichaCotitularidad.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad"]
    }
  },
  {
    path: "/ficha-cotitularidad-nf",
    name: "ficha-cotitularidad-nf",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad-nf" */ "@/views/fichas/FichaCotitularidad.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad-nf"]
    }
  },
  {
    path: "/ficha-cotitularidad/nuevo",
    name: "ficha-cotitularidad-nuevo",
    component: () =>
      import(
        /* webpackChunkName:"ficha-cotitularidad-nuevo" */ "@/views/fichas/FichaCotitularidadAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad"]
    }
  },
  {
    path: "/ficha-cotitularidad-nf/nuevo",
    name: "ficha-cotitularidad-nf-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad-nf-nuevo" */ "@/views/fichas/FichaCotitularidadAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad-nf"]
    }
  },
  {
    path: "/ficha-cotitularidad/:idficha/editar",
    name: "ficha-cotitularidad-editar",
    component: () =>
      import(
        /* webpackChunkName:"ficha-cotitularidad-editar" */ "@/views/fichas/FichaCotitularidadAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad"]
    }
  },
  {
    path: "/ficha-cotitularidad-nf/:idficha/editar",
    name: "ficha-cotitularidad-nf-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad-nf-editar" */ "@/views/fichas/FichaCotitularidadAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad-nf"]
    }
  },

  /**
   * FICHA COTITULARIDAD RURAL
   */
  {
    path: "/ficha-cotitularidad-rural",
    name: "ficha-cotitularidad-rural",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad" */ "@/views/fichas/FichaCotitularidadRural.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad-rural"]
    }
  },
  {
    path: "/ficha-cotitularidad-rural-nf",
    name: "ficha-cotitularidad-rural-nf",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad-nf" */ "@/views/fichas/FichaCotitularidadRural.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad-rural-nf"]
    }
  },
  {
    path: "/ficha-cotitularidad-rural/:idficha/editar",
    name: "ficha-cotitularidad-rural-editar",
    component: () =>
      import(
        /* webpackChunkName:"ficha-cotitularidadrural-editar" */ "@/views/fichas/FichaCotitularidadRuralAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad-rural"]
    }
  },
  {
    path: "/ficha-cotitularidad-rural-nf/:idficha/editar",
    name: "ficha-cotitularidad-rural-nf-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidadrural-nf-editar" */ "@/views/fichas/FichaCotitularidadRuralAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-cotitularidad-rural-nf"]
    }
  },
  /**
   * FICHA ECONOMICA
   */
  {
    path: "/ficha-economica",
    name: "ficha-economica",
    component: () =>
      import(/* webpackChunkName: "ficha-economica" */ "@/views/fichas/FichaEconomica.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-economica"]
    }
  },
  {
    path: "/ficha-economica-nf",
    name: "ficha-economica-nf",
    component: () =>
      import(/* webpackChunkName: "ficha-economica-nf" */ "@/views/fichas/FichaEconomica.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-economica-nf"]
    }
  },
  {
    path: "/ficha-economica/nuevo",
    name: "ficha-economica-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-economica-nuevo" */ "@/views/fichas/FichaEconomicaAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-economica"]
    }
  },
  {
    path: "/ficha-economica-nf/nuevo",
    name: "ficha-economica-nf-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-economica-nf-nuevo" */ "@/views/fichas/FichaEconomicaAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-economica-nf"]
    }
  },
  {
    path: "/ficha-economica/:idficha/editar",
    name: "ficha-economica-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-economica-editar" */ "@/views/fichas/FichaEconomicaAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-economica"]
    }
  },
  {
    path: "/ficha-economica-nf/:idficha/editar",
    name: "ficha-economica-nf-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-economica-nf-editar" */ "@/views/fichas/FichaEconomicaAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-economica-nf"]
    }
  },

  /**
   * FICHA BIEN COMÚN
   */
  {
    path: "/ficha-biencomun",
    name: "ficha-biencomun",
    component: () =>
      import(/* webpackChunkName: "ficha-biencomun" */ "@/views/fichas/FichaBienComun.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencomun"]
    }
  },
  {
    path: "/ficha-biencomun-nf",
    name: "ficha-biencomun-nf",
    component: () =>
      import(/* webpackChunkName: "ficha-biencomun-nf" */ "@/views/fichas/FichaBienComun.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencomun-nf"]
    }
  },
  {
    path: "/ficha-biencomun/nuevo",
    name: "ficha-biencomun-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencomun-nuevo" */ "@/views/fichas/FichaBienComunAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencomun"]
    }
  },
  {
    path: "/ficha-biencomun-nf/nuevo",
    name: "ficha-biencomun-nf-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencomun-nf-nuevo" */ "@/views/fichas/FichaBienComunAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencomun-nf"]
    }
  },
  {
    path: "/ficha-biencomun/:idficha/editar",
    name: "ficha-biencomun-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencomun-editar" */ "@/views/fichas/FichaBienComunAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencomun"]
    }
  },
  {
    path: "/ficha-biencomun-nf/:idficha/editar",
    name: "ficha-biencomun-nf-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencomun-nf-editar" */ "@/views/fichas/FichaBienComunAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencomun-nf"]
    }
  },

  /**
   * FICHA BIEN CULTURAL
   */
  {
    path: "/ficha-biencultural",
    name: "ficha-biencultural",
    component: () =>
      import(/* webpackChunkName: "ficha-biencultural" */ "@/views/fichas/FichaBienCultural.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencultural"]
    }
  },
  {
    path: "/ficha-biencultural-nf",
    name: "ficha-biencultural-nf",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencultural-nf" */ "@/views/fichas/FichaBienCultural.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencultural-nf"]
    }
  },
  {
    path: "/ficha-biencultural/nuevo",
    name: "ficha-biencultural-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencultural-nuevo" */ "@/views/fichas/FichaBienCulturalAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencultural"]
    }
  },
  {
    path: "/ficha-biencultural-nf/nuevo",
    name: "ficha-biencultural-nf-nuevo",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencultural-nf-nuevo" */ "@/views/fichas/FichaBienCulturalAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencultural-nf"]
    }
  },
  {
    path: "/ficha-biencultural/:idficha/editar",
    name: "ficha-biencultural-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencultural-editar" */ "@/views/fichas/FichaBienCulturalAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencultural"]
    }
  },
  {
    path: "/ficha-biencultural-nf/:idficha/editar",
    name: "ficha-biencultural-nf-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencultural-nf-editar" */ "@/views/fichas/FichaBienCulturalAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-biencultural-nf"]
    }
  },

  /**
   * FICHA RURAL
   */
  {
    path: "/ficha-rural",
    name: "ficha-rural",
    component: () => import(/* webpackChunkName: "ficha-rural" */ "@/views/fichas/FichaRural.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-rural"]
    }
  },
  {
    path: "/ficha-rural-nf",
    name: "ficha-rural-nf",
    component: () =>
      import(/* webpackChunkName: "ficha-rural-nf" */ "@/views/fichas/FichaRural.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-rural-nf"]
    }
  },
  {
    path: "/ficha-rural/nuevo",
    name: "ficha-rural-nuevo",
    component: () =>
      import(/* webpackChunkName: "ficha-rural-nuevo" */ "@/views/fichas/FichaRuralAddEdit.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-rural"]
    }
  },
  {
    path: "/ficha-rural-nf/nuevo",
    name: "ficha-rural-nf-nuevo",
    component: () =>
      import(/* webpackChunkName: "ficha-rural-nf-nuevo" */ "@/views/fichas/FichaRuralAddEdit.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-rural-nf"]
    }
  },
  {
    path: "/ficha-rural/:idficha/editar",
    name: "ficha-rural-editar",
    component: () =>
      import(/* webpackChunkName: "ficha-rural-editar" */ "@/views/fichas/FichaRuralAddEdit.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-rural"]
    }
  },
  {
    path: "/ficha-rural-nf/:idficha/editar",
    name: "ficha-rural-nf-editar",
    component: () =>
      import(
        /* webpackChunkName: "ficha-rural-nf-editar" */ "@/views/fichas/FichaRuralAddEdit.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/ficha-rural-nf"]
    }
  },
  {
    path: "/planocatastral",
    name: "planocatastral",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/PlanoCatastral.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/planocatastral"]
    }
  },
  {
    path: "/constancia-negativo",
    name: "constancia-negativo",
    component: () =>
      import(
        /* webpackChunkName: "planocatastral" */ "@/views/documento/ConstanciaNegativoCat.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/constancia-negativo"]
    }
  },
  {
    path: "/constancia-posesion",
    name: "constancia-posesion",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/ConstanciaPosesion.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/constancia-posesion"]
    }
  },
  {
    path: "/constancia-posesion/:id",
    name: "constancia-posesion-edit",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/ConstanciaPosesionDocumento.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/constancia-posesion"]
    }
  },
  {
    path: "/certificado-posesion",
    name: "certificado-posesion",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/CertificadoPosesion.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/certificado-posesion"]
    }
  },
  {
    path: "/certificado-numeracion",
    name: "certificado-numeracion",
    component: () =>
      import(
        /* webpackChunkName: "planocatastral" */ "@/views/documento/CertificadoNumeracion.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/certificado-numeracion"]
    }
  },
  {
    path: "/certificado-autorizacion-licencias",
    name: "certificado-autorizacion-licencias",
    component: () =>
      import(
        /* webpackChunkName: "planocatastral" */ "@/views/documento/CertificadoAutorizacionLicencias.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/certificado-autorizacion-licencias"]
    }
  },
  {
    path: "/archivo/:idficha",
    name: "archivo",
    component: () => import(/* webpackChunkName: "archivos" */ "@/views/fichas/Fotos.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/archivo"]
    }
  },
  {
    path: "/certificado-catastral",
    name: "certificado-catastral",
    component: () =>
      import(/* webpackChunkName: "planocatastral" */ "@/views/documento/CertificadoCatastral.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/certificado-catastral"]
    }
  },

  /* ESTADISTICA */
  /* FICHA COTITULAR */
  {
    path: "/estadistica-ficha-individual",
    name: "estadistica-ficha-individual",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad" */ "@/views/estadistica/EstadisticaFichaIndividual.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-ficha-individual"]
    }
  },
  {
    path: "/estadistica-ficha-cotitularidad",
    name: "estadistica-ficha-cotitularidad",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad" */ "@/views/estadistica/EstadisticaFichaCotitularidad.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-ficha-cotitularidad"]
    }
  },
  {
    path: "/estadistica-ficha-bien-comun",
    name: "estadistica-ficha-bien-comun",
    component: () =>
      import(
        /* webpackChunkName: "ficha-biencomun" */ "@/views/estadistica/EstadisticaFichaBienComun.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-ficha-bien-comun"]
    }
  },
  {
    path: "/estadistica-ficha-rural",
    name: "estadistica-ficha-rural",
    component: () =>
      import(/* webpackChunkName: "ficha-rural" */ "@/views/estadistica/EstadisticaFichaRural.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-ficha-rural"]
    }
  },
  {
    path: "/estadistica-ficha-economica",
    name: "estadistica-ficha-economica",
    component: () =>
      import(
        /* webpackChunkName: "ficha-economica" */ "@/views/estadistica/EstadisticaFichaEconomica.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-ficha-economica"]
    }
  },
  {
    path: "/estadistica-ficha-bien-cultural",
    name: "estadistica-ficha-bien-cultural",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad" */ "@/views/estadistica/EstadisticaFichaBienCultural.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-ficha-bien-cultural"]
    }
  },
  {
    path: "/estadistica-ficha-cotitularidad-rural",
    name: "estadistica-ficha-cotitularidad-rural",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad-rural" */ "@/views/estadistica/EstadisticaFichaCotitularidadRural.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-ficha-cotitularidad-rural"]
    }
  },
  {
    path: "/estadistica-resumen-ficha",
    name: "estadistica-resumen-ficha",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad" */ "@/views/estadistica/EstadisticaResumenFichas.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-resumen-ficha"]
    }
  },
  {
    path: "/estadistica-resumen-documento",
    name: "estadistica-resumen-documento",
    component: () =>
      import(
        /* webpackChunkName: "ficha-cotitularidad" */ "@/views/estadistica/EstadisticaResumenDocumentos.vue"
      ),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/estadistica-resumen-documento"]
    }
  },

  // REPOTES

  {
    path: "/reporte-sector",
    name: "reporte-sector",
    component: () =>
      import(/* webpackChunkName: "ficha-cotitularidad" */ "@/views/reporte/ReporteSector.vue"),
    meta: {
      layout: LayoutSistem,
      isPublic: false,
      availableRoute: ["/reporte-sector"]
    }
  }
];
